"use client";

import { useState, useEffect, useRef, useContext } from "react";
import { UIContext } from "@/contexts/UIContext";
import Link from "next/link";

const UserSelect = ({
  thisUser,
  callback,
  tagsTable = [],
  placeholder = "Type a name or @handle",
  presetUsers = [],
  isMulti = true,
  followsMe = [],
  followedByMe =[],
}) => {
  console.log('followsMe', followsMe)
  const { setError } = useContext(UIContext);

  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const inputRef = useRef(null);

  /* -----------------------------
     Initialize preset users
  ----------------------------- */
// useEffect(() => {
//   // NEW CHAT → reset local state only
//   if (!presetUsers || presetUsers.length === 0) {
//     setSelectedUsers([]);
//     setQuery("");
//     setSuggestions([]);
//     return;
//   }

//   // EXISTING CHAT → initialize fixed users
//   const fixed = presetUsers.map(u => ({
//     ...u,
//     label: `@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`,
//     isFixed: true,
//   }));

//   setSelectedUsers(fixed);

// }, [presetUsers]);


// const initializedRef = useRef(false);

// useEffect(() => {
//   if (initializedRef.current) return;

//   if (presetUsers?.length) {
//     const fixed = presetUsers.map(u => ({
//       ...u,
//       label: `@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`,
//       isFixed: true,
//     }));

//     setSelectedUsers(fixed);
//     initializedRef.current = true;
//   }
// }, [presetUsers]);









// const initializedChatRef = useRef(null);
// useEffect(() => {
//   console.log("PRESETUSERS@useEffect", presetUsers);
  
//   // Create a unique key that includes array length for empty arrays
//   const chatKey = presetUsers?.length > 0 
//     ? presetUsers.map(u => u.user_uuid).sort().join(',')
//     : `empty-${Date.now()}`; // Unique key for each empty state
  
//   // Only update if the chat has actually changed
//   if (initializedChatRef.current === chatKey) {
//     return;
//   }
  
//   initializedChatRef.current = chatKey;
  
//   if (!presetUsers || presetUsers.length === 0) {
//     setSelectedUsers([]);
//     return;
//   }
  
//   const fixed = presetUsers.map(u => ({
//     ...u,
//     label: `@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`,
//     isFixed: true,
//   }));
  
//   setSelectedUsers(fixed);
  
// }, [presetUsers]);



// WOW WORKS
const initializedChatRef = useRef(null);
useEffect(() => {
  console.log("PRESETUSERS@useEffect", presetUsers);
  
  if (!presetUsers || presetUsers.length === 0) {
    setSelectedUsers([]);
    setQuery("");
    setSuggestions([]);
    return;
  }
  
  const fixed = presetUsers.map(u => ({
    ...u,
    label: <Link className={'hover:text-teal-400'} href={`/@${u.user_handle}`}><span>{`@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`}</span><i className={`fa-solid fa-arrow-right transition-all duration-150 -rotate-45`}></i></Link>,
    isFixed: true,
  }));
  
  setSelectedUsers(fixed);
  
}, [presetUsers?.length, presetUsers?.map(u => u.user_uuid).join(',')]);
// useEffect(() => {
//   console.log("PRESETUSERS@useEffect", presetUsers);
  
//   const chatKey = presetUsers?.map(u => u.user_uuid).sort().join(',') || 'empty';
  
//   // Only update if the chat has actually changed
//   if (initializedChatRef.current === chatKey) {
//     return;
//   }
  
//   initializedChatRef.current = chatKey;
  
//   if (!presetUsers || presetUsers.length === 0) {
//     setSelectedUsers([]);
//     return;
//   }
  
//   const fixed = presetUsers.map(u => ({
//     ...u,
//     label: `@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`,
//     isFixed: true,
//   }));
  
//   setSelectedUsers(fixed);
  
// }, [presetUsers]);




// sorta works 
// useEffect(() => {
//   console.log("PRESETUSERS@useEffect", presetUsers)
  
//   // Generate a stable key from presetUsers to detect actual changes
//   const presetKey = presetUsers?.map(u => u.user_uuid).sort().join(',');
  
//   if (!presetUsers || presetUsers.length === 0) {
//     setSelectedUsers([]);
//     return;
//   }
  
//   const fixed = presetUsers.map(u => ({
//     ...u,
//     label: `@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`,
//     isFixed: true,
//   }));
  
//   setSelectedUsers(fixed);
  
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, [presetUsers?.map(u => u.user_uuid).join(',')]); // Stable dependency


// WORKS 
// useEffect(() => {
//      console.log("PRESETUSERS@useEffect", presetUsers)
//      if (presetUsers.length === 0) {setSelectedUsers([]);return ;}
//      if (presetUsers?.length) {
//           const fixed = presetUsers.map(u => ({
//                ...u,
//                label: `@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`,
//                isFixed: true,
//           }));
//           setSelectedUsers(fixed);
          
//           // callback({ selectedUsers: fixed });
//      } 
//      // else {
//      //      // NEW CHAT - clear everything
//      //      setSelectedUsers([]);
//      //      setQuery("");
//      //      setSuggestions([]);
//      //      callback({ selectedUsers: [] });
//      // }

// }, [presetUsers]);














//   useEffect(() => {
//      console.log("PRESETUSERS@useEffect", presetUsers)

//      if (presetUsers?.length) {
//           const fixed = presetUsers.map(u => ({
//                ...u,
//                label: `@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`,
//                isFixed: true,
//           }));
//           setSelectedUsers(fixed);
//           callback({ selectedUsers: fixed });
//     }


//   }, [presetUsers]);

  /* -----------------------------
     Autocomplete filtering
  ----------------------------- */
  useEffect(() => {
    if (!query || (query.length < 4 && thisUser.user_roles.role !== 'ROOT')) {
      setSuggestions([]);
      return;
    }

    const q = query.toLowerCase();

    const filtered = tagsTable
      .filter(u =>
        u.user_uuid !== thisUser.user_uuid && // filter out thisUser from results
        (u.user_handle?.toLowerCase().includes(q) ||
        `${u.user_first_name} ${u.user_last_name}`.toLowerCase().includes(q))
      )
      .filter(
        u => !selectedUsers.some(sel => sel.user_uuid === u.user_uuid)
      )
      .slice(0, 6)
      .map(u => ({
        ...u,
        label: `@${u.user_handle} (${u.user_first_name} ${u.user_last_name})`,
      }));

    setSuggestions(filtered);
  }, [query, tagsTable, selectedUsers]);

  /* -----------------------------
     Add / remove users
  ----------------------------- */
  const addUser = user => {
    if (!isMulti && selectedUsers.length) return;

    const next = [...selectedUsers, user];
    setSelectedUsers(next);
    setQuery("");
    setSuggestions([]);
    callback({ selectedUsers: next });
  };

  const removeUser = user_uuid => {
    const user = selectedUsers.find(u => u.user_uuid === user_uuid);
    if (user?.isFixed) return;

    const next = selectedUsers.filter(u => u.user_uuid !== user_uuid);
    setSelectedUsers(next);
    callback({ selectedUsers: next });
  };

  /* -----------------------------
     Keyboard handling
  ----------------------------- */
  const handleKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (suggestions.length) {
        addUser(suggestions[0]);
      }
    }

    if (e.key === "Backspace" && !query && selectedUsers.length) {
      const last = selectedUsers[selectedUsers.length - 1];
      if (!last.isFixed) removeUser(last.user_uuid);
    }
  };

  return (
    <div className="relative w-full">
      {/* Pills */}
      <div className="flex flex-wrap gap-2 border dark:border-slate-700 rounded px-2 py-2 dark:bg-slate-800">
        {selectedUsers.map(user => (
          <span
            key={user.user_uuid}
            className="flex items-center gap-1 bg-slate-200 dark:bg-slate-700 px-2 py-1 rounded-full text-sm"
          >
            {user.label}
            {!user.isFixed && (
              <button
                onClick={() => removeUser(user.user_uuid)}
                className="text-xs hover:text-red-500"
              >
                ×
              </button>
            )}
          </span>
        ))}

        <input
        disabled={!isMulti && selectedUsers.length} // for now, remove this later for group chats (cap at 1 now)
          ref={inputRef}
          value={query}
          onChange={e => setQuery(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={!isMulti && selectedUsers.length ? '' : placeholder}
          className="flex-1 min-w-[160px] bg-transparent outline-none text-sm"
        />
      </div>

      {/* Suggestions */}
      {suggestions.length > 0 && (
        <ul className="absolute z-50 mt-1 w-full min-h-full bg-white dark:bg-slate-800 border dark:border-slate-700 rounded shadow">
          {suggestions.map(user => (
            <li
              key={user.user_uuid}
              onClick={() => addUser(user)}
              className="px-3 py-2 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700"
            >
              {user.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default UserSelect;